import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReportingConfigResponse } from '@rx-applications/clientsite/shared/config/utils';
import { HttpService } from '@rx-applications/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsConfigAPI {
  constructor(private http: HttpClient, private httpService: HttpService) {}

  getAnalyticsConfig() {
    return this.http.get<ReportingConfigResponse>(
      `${this.httpService.webApiUrl}Config/GetReportingConfig`
    );
  }
}
